<template>
    <gmap-map
        ref="map"
        :center="center"
        :zoom="zoomValue"
        @bounds_changed="$emit('boundsChanged', $refs.map)"
    >
        <prospects-renderer
            v-if="mapLoaded"
            :drawing-manager="drawingManager"
            :can-edit="canEdit"
            :prospects="paths"
            @rendered="$emit('rendered')"
        />
        <slot />
    </gmap-map>
</template>

<script>
    import Drawing from '../../Maps/Drawing';
    import Coordinates from '../../Maps/Coordinates';
    import ProspectsRenderer from './Renderers/ProspectsRenderer';

    export default {
        components: {
            ProspectsRenderer,
        },
        props: {
            prospects: {
                type: Array,
                default: null,
            },
            center: {
                required: false,
                type: Object,
                default: () => {
                    return window.defaultMapCenter;
                },
            },
            canDraw: {
                type: Boolean,
                default: false,
            },
            canEdit: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                initialLoad: true,
                mapLoaded: false,
                drawingInitialized: false,
                drawingManager: null,
            };
        },
        computed: {
            zoomValue() {
                return parseInt(4);
            },
            paths() {
                return this.prospects.map((prospect) => {
                    return {
                        path: prospect.polygon_path,
                        id: prospect.id,
                        communities: prospect.communities,
                    };
                });
            },
        },
        watch: {
            mapLoaded(isLoaded) {
                if (! isLoaded) {
                    return;
                }

                this.$emit('rendered', true);
            },
        },
        created() {
            this.$nextTick(() => {
                this.$refs.map.$mapPromise.then(() => {
                    this.drawingManager = new Drawing(this.$refs.map.$mapObject);
                    this.mapLoaded = true;
                    this.drawShapes();
                });
            });

            EventBus.$on(
                'zoom-to-shape',
                shapeId => this.zoomToShape(shapeId),
            );

            EventBus.$on(
                'clear-last-shape',
                () => {
                    this.drawingManager.resetLastShape();
                },
            );

            EventBus.$on(
                'clear-user-created-shapes',
                (drawnShapes) => {
                    this.drawingManager.resetShapes(drawnShapes);
                },
            );

            EventBus.$on(
                'prospects-shapes-drawn',
                () => {
                    if (this.drawingManager.shapes.length > 0) {
                        this.drawingManager.fitToShapes(this.drawingManager.shapes);
                    }
                },
            );
        },
        methods: {
            zoomToShape(shapeId) {
                this.drawingManager.fitToShape(shapeId);
            },
            drawShapes() {
                if (! this.mapLoaded) {
                    return;
                }

                if (! this.coordinates) {
                    this.coordinates = new Coordinates();
                }

                if (this.canDraw && ! this.drawingInitialized) {
                    this.drawingInitialized = true;
                    this.drawingManager.initializeDrawing();
                    this.drawingManager.finishedDrawing((shape) => {
                        const coordinates = this.coordinates.getCoordinatesFromShape(shape);
                        const polygon = this.coordinates.getStringifiedCoordinates(coordinates);
                        EventBus.$emit('shape-drawn', polygon, shape);
                    });
                }
            },
        },
    };
</script>